import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IntegrationCardConfig } from '../..';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './integration-card.hooks';

@Component({
	selector: 'app-integration-card',
	templateUrl: './integration-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IntegrationCardComponent {
	testHooks = TestHooks;
	@Input() integration: IntegrationCardConfig;
	@Input() integrationKey: string;

	constructor(private navService: NavigationService) {}
	public redirectToIntegration(): void {
		this.navService.goToUrl(this.integration.href);
	}
}
